// @core/api/endpoints/secret/destroy_kv_secret_versions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DestroyKvSecretVersionsRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Destroy KV secret versions
 * Permanently destroys specified versions of a KV secret. Destroyed versions cannot be recovered. The secret path itself remains until all versions are destroyed.
 */
export async function DestroyKvSecretVersions(
  engine_id: string,
  path: string,
  data: DestroyKvSecretVersionsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/kv/destroy/:path`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':path', encodeURIComponent(path));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
